import React, { useEffect } from "react"
import './App.css'
import IcomoonReact, { ImCheckmark } from "icomoon-react"

// import HomePage from './pages/Home'
// import LoginPage from './pages/Login'
// import SelectProduct from './pages/Select-product'

import AuthProvider from "./provider/authProvider"
import Routes from "./routes"

function App() {
    return (
        <AuthProvider>
            <Routes />
        </AuthProvider>
    );
}

export default App;
